var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import Immutable from 'seamless-immutable';
import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { ELSLoggingService } from '@els/els-ui-common-react';
import { AppConstant, SORT_DIRECTION_ENUM } from 'constants/app.constant';
import { appActions } from 'redux/ducks/app';
import { fetchAssignmentDetail, fetchAssignmentInfo, fetchCourseSectionRoles, fetchEAQFeatures, fetchAssignmentEngagements, fetchStudentEngagements, fetchEngagementSummary } from 'reports/cw/services/report.service';
import { ALL_EAQ_ASSIGNMENT_TYPE, ASSIGNMENT_TYPES } from 'reports/cw/constants/report.constant';
import { getAssignmentTypeOptions } from 'reports/cw/components/pages/engagement/Engagement';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { isEAQStandalone } from 'reports/cw/services/courses.service';
import { filterActions } from 'redux/ducks/filter';
import { engagementSummarySortOption, getSortedEngagementSummary } from 'reports/cw/components/pages/engagement-summary/engagement-summary-sort/EngagementSummarySort';
var fileName = 'Courseware redux';
var initialState = Immutable({
    studentEngagement: null,
    assignmentEngagement: null,
    assignmentReport: null,
    assignmentTypeOptions: [],
    engagementSummary: null,
    courseAggregateData: [],
    courseAggregateOriginalData: [],
    isEngagementSummaryLoading: true,
    isReportLoading: false,
    isAssignmentDetailLoading: false,
    isAssignmentEngagementReportLoading: true,
    isStudentEngagementReportLoading: true,
    isCourseAggregateReportLoading: true,
    featureItems: [],
    isAssignmentReportFeatureShown: null,
    assignmentInfo: null,
    assignmentSummaryCardAndTableSortInteraction: null,
    assignmentEngagementCardAndTableSortInteraction: null,
    engagementSummaryCardAndTableSortInteraction: null,
    studentEngagementSort: null,
    studentHomeCardAndAssignmentSummaryTableSortInteraction: null,
    studentHomeCardPerformLinkAndAssignmentSummaryTableSortInteraction: null,
    studentHomeCardPerformLinkAndAssignmentEngagementTableSortInteraction: null,
    studentDetailCardAndAssignmentSummaryTableSortInteraction: null,
    selectedStudentId: '',
    totalCompletedAssignments: 0,
    assignmentSummaryCard: {
        totalAssignments: 0,
        totalCompletedAssignments: 0,
        highPerformanceStudents: 0,
        totalStudents: 0,
        disengagedStudents: 0
    },
    engagementSummaryCard: {
        classAvgScore: 0,
        totalAssignments: 0,
        totalCompletedAssignments: 0,
        totalStudents: 0,
        totalStudentsPastDue: 0
    }
});
var prefixActionName = 'CW';
var restoreState = createAction("".concat(prefixActionName, "/RESTORE"));
var setStudentEngagement = createAction("".concat(prefixActionName, "/SET_STUDENT_ENGAGEMENT"));
var setAssignmentEngagement = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_ENGAGEMENT"));
var setEngagementSummary = createAction("".concat(prefixActionName, "/SET_ENGAGEMENT_SUMMARY"));
var setIsEngagementSummaryLoading = createAction("".concat(prefixActionName, "/SET_IS_ENGAGEMENT_SUMMARY_LOADING"));
var setAssignmentSummaryCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_SUMMARY_CARD_AND_TABLE_SORT_INTERACTION"));
var setAssignmentInfo = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_INFO"));
var setAssignmentTypeOptions = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_TYPE_OPTIONS"));
var setAssignmentDetail = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_DETAIL"));
var setCourseAggregateData = createAction("".concat(prefixActionName, "/SET_COURSE_AGGREGATE_DATA"));
var setCourseAggregateOriginalData = createAction("".concat(prefixActionName, "/SET_COURSE_AGGREGATE_ORIGINAL_DATA"));
var setIsAssignmentDetailLoading = createAction("".concat(prefixActionName, "/SET_IS_ASSIGNMENT_DETAIL_LOADING"));
var setIsAssignmentEngagementReportLoading = createAction("".concat(prefixActionName, "/SET_IS_ASSIGNMENT_ENGAGEMENT_REPORT_LOADING"));
var setIsStudentEngagementReportLoading = createAction("".concat(prefixActionName, "/SET_IS_STUDENT_ENGAGEMENT_REPORT_LOADING"));
var setReportLoading = createAction("".concat(prefixActionName, "/SET_REPORT_LOADING"));
var setIsCourseAggregateReportLoading = createAction("".concat(prefixActionName, "/SET_IS_COURSE_AGGREGATE_REPORT_LOADING"));
var setFeatureItems = createAction("".concat(prefixActionName, "/SET_FEATURE_ITEMS"));
var setStudentEngagementSort = createAction("".concat(prefixActionName, "/SET_STUDENT_ENGAGEMENT_SORT"));
var setAssignmentEngagementCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_ENGAGEMENT_CARD_AND_TABLE_SORT_INTERACTION"));
var setEngagementSummaryCardAndTableSortInteraction = createAction("".concat(prefixActionName, "/SET_ENGAGEMENT_SUMMARY_CARD_AND_TABLE_SORT_INTERACTION"));
var setStudentHomeCardAndAssignmentEngagementTableSortInteraction = createAction("".concat(prefixActionName, "/SET_STUDENT_HOME_CARD_AND_ASSIGNMENT_ENGAGEMENT_TABLE_INTERACTION"));
var setStudentHomeCardPerformLinkAndAssignmentSummaryTableSortInteraction = createAction("".concat(prefixActionName, "/SET_STUDENT_HOME_CARD_PERFORM_LINK_AND_ASSIGNMENT_SUMMARY_TABLE_INTERACTION"));
var setStudentHomeCardPerformLinkAndAssignmentEngagementTableSortInteraction = createAction("".concat(prefixActionName, "/SET_STUDENT_HOME_CARD_PERFORM_LINK_AND_ASSIGNMENT_ENGAGEMENT_TABLE_INTERACTION"));
var setStudentDetailCardAndAssignmentSummaryTableSortInteraction = createAction("".concat(prefixActionName, "/SET_STUDENT_DETAIL_CARD_AND_ASSIGNMENT_SUMMARY_TABLE_INTERACTION"));
var setSelectedStudentId = createAction("".concat(prefixActionName, "/SET_SELECTED_STUDENT_ID"));
var setTotalCompletedAssignments = createAction("".concat(prefixActionName, "/SET_TOTAL_COMPLETED_ASSIGNMENTS"));
var setAssignmentSummaryCard = createAction("".concat(prefixActionName, "/SET_ASSIGNMENT_SUMMARY_CARD"));
var fetchAssignmentDetailReport = function (assignmentID) { return function (dispatch) {
    dispatch(setIsAssignmentDetailLoading(true));
    Promise.all([fetchAssignmentInfo(assignmentID), fetchAssignmentDetail(assignmentID)])
        .then(function (results) {
        dispatch(setAssignmentInfo(results[0]));
        dispatch(setAssignmentDetail(results[1]));
    })
        .catch(function (err) {
        ELSLoggingService.error(fileName, "Error while attempting to fetch data of assignment with id=".concat(assignmentID, ", error: ").concat(err.message));
    })
        .finally(function () {
        dispatch(setIsAssignmentDetailLoading(false));
    });
}; };
// "All EAQ" is a client-only pseudo-type (see ALL_EAQ_ASSIGNMENT_TYPE) - the backend has no matching
// contentType, so omitting the param returns metrics across every assignment type in the course, not
// just EAQ ones. Assignment-side data is filtered back down to EAQ in getFilteredAssignmentEngagement;
// TODO INS-6452: student-side data (fetchStudentEngagementReport) is NOT filtered the same way, so under
// "All EAQ" the student metrics can include non-EAQ assignment types if the course has any.
var toApiContentType = function (assignmentType) { return (assignmentType === ALL_EAQ_ASSIGNMENT_TYPE.id ? undefined : assignmentType); };
var fetchStudentEngagementReport = function (courseId, assignmentType) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var apiContentType, studentEngagementResponse, adaptiveLessonStudentEngagementResponse, err_1;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                dispatch(setIsStudentEngagementReportLoading(true));
                _e.label = 1;
            case 1:
                _e.trys.push([1, 5, 6, 7]);
                apiContentType = toApiContentType(assignmentType);
                return [4 /*yield*/, fetchStudentEngagements(courseId, apiContentType)];
            case 2:
                studentEngagementResponse = _e.sent();
                if (!(assignmentType === ASSIGNMENT_TYPES.LESSONS.id)) return [3 /*break*/, 4];
                return [4 /*yield*/, fetchStudentEngagements(courseId, ASSIGNMENT_TYPES.ADAPTIVE_LESSON.id)];
            case 3:
                adaptiveLessonStudentEngagementResponse = _e.sent();
                if (((_b = (_a = adaptiveLessonStudentEngagementResponse.data) === null || _a === void 0 ? void 0 : _a.metrics) === null || _b === void 0 ? void 0 : _b.length) > ((_d = (_c = studentEngagementResponse.data) === null || _c === void 0 ? void 0 : _c.metrics) === null || _d === void 0 ? void 0 : _d.length)) {
                    studentEngagementResponse = adaptiveLessonStudentEngagementResponse;
                }
                _e.label = 4;
            case 4:
                dispatch(setStudentEngagement(studentEngagementResponse));
                return [3 /*break*/, 7];
            case 5:
                err_1 = _e.sent();
                ELSLoggingService.error(fileName, "Failed to fetch student engagement data: ".concat(err_1.message));
                return [3 /*break*/, 7];
            case 6:
                dispatch(setIsStudentEngagementReportLoading(false));
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}); }; };
var buildAssignmentTypeOptions = function (listContentTypeAvailable, dispatch, getState) {
    var _a;
    var isEAQStandaloneCourse = isEAQStandalone(courseSelectors.getCourseSectionInfo(getState()));
    var assignmentTypeOptions = getAssignmentTypeOptions(listContentTypeAvailable || [], isEAQStandaloneCourse);
    if (assignmentTypeOptions.findIndex(function (typeOption) { return (typeOption === null || typeOption === void 0 ? void 0 : typeOption.key) === getState()[AppConstant.reduxResources.FILTER_STATE].cwEngagementAssignmentTypeDropdownId; }) === -1) {
        dispatch(filterActions.setCWEngagementAssignmentTypeDropdownId((_a = assignmentTypeOptions[0]) === null || _a === void 0 ? void 0 : _a.key));
    }
    dispatch(setAssignmentTypeOptions(assignmentTypeOptions));
};
var fetchAssignmentEngagementReport = function (courseId, assignmentType) {
    if (assignmentType === void 0) { assignmentType = null; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var data, listContentTypeAvailable, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setIsAssignmentEngagementReportLoading(true));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchAssignmentEngagements(courseId, toApiContentType(assignmentType))];
                case 2:
                    data = (_a.sent()).data;
                    listContentTypeAvailable = data.listContentTypeAvailable;
                    buildAssignmentTypeOptions(listContentTypeAvailable, dispatch, getState);
                    dispatch(setAssignmentEngagement(data));
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    ELSLoggingService.error(fileName, "Failed to fetch assignment engagement data: ".concat(err_2.message));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setIsAssignmentEngagementReportLoading(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
var initializeCourseSectionRoles = function (userId) { return function (dispatch) {
    fetchCourseSectionRoles(userId).then(function (courseRolesData) {
        dispatch(appActions.setCourseSectionRoles(courseRolesData));
    });
}; };
var fetchFeatureItems = function () { return function (dispatch) {
    fetchEAQFeatures().then(function (data) {
        dispatch(setFeatureItems(data));
    });
}; };
var fetchEngagementSummaryReport = function (courseSectionId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var engagementSummary, filteredTypeCardsListByType, filteredEngagementSummaryAssignmentByType, sortedEngagementSummary, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(setIsEngagementSummaryLoading(true));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, fetchEngagementSummary(courseSectionId)];
            case 2:
                engagementSummary = (_a.sent()).data;
                filteredTypeCardsListByType = (engagementSummary.typeCardsList || []).filter(function (card) { return ASSIGNMENT_TYPES[card.assignmentType]; });
                filteredEngagementSummaryAssignmentByType = __assign(__assign({}, engagementSummary), { typeCardsList: filteredTypeCardsListByType });
                sortedEngagementSummary = getSortedEngagementSummary(filteredEngagementSummaryAssignmentByType, SORT_DIRECTION_ENUM.desc, engagementSummarySortOption[0].value);
                dispatch(setEngagementSummary(sortedEngagementSummary));
                return [3 /*break*/, 5];
            case 3:
                err_3 = _a.sent();
                ELSLoggingService.error("".concat(fileName, " - Failed to fetch engagement summary data. Message: "), err_3.message);
                return [3 /*break*/, 5];
            case 4:
                dispatch(setIsEngagementSummaryLoading(false));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
var actions = {
    restoreState: restoreState,
    setAssignmentSummaryCardAndTableSortInteraction: setAssignmentSummaryCardAndTableSortInteraction,
    setAssignmentEngagementCardAndTableSortInteraction: setAssignmentEngagementCardAndTableSortInteraction,
    setEngagementSummaryCardAndTableSortInteraction: setEngagementSummaryCardAndTableSortInteraction,
    setStudentEngagementSort: setStudentEngagementSort,
    setStudentHomeCardAndAssignmentEngagementTableSortInteraction: setStudentHomeCardAndAssignmentEngagementTableSortInteraction,
    setStudentHomeCardPerformLinkAndAssignmentSummaryTableSortInteraction: setStudentHomeCardPerformLinkAndAssignmentSummaryTableSortInteraction,
    setStudentHomeCardPerformLinkAndAssignmentEngagementTableSortInteraction: setStudentHomeCardPerformLinkAndAssignmentEngagementTableSortInteraction,
    setStudentDetailCardAndAssignmentSummaryTableSortInteraction: setStudentDetailCardAndAssignmentSummaryTableSortInteraction,
    setAssignmentInfo: setAssignmentInfo,
    setAssignmentTypeOptions: setAssignmentTypeOptions,
    setAssignmentDetail: setAssignmentDetail,
    setIsAssignmentDetailLoading: setIsAssignmentDetailLoading,
    setIsAssignmentEngagementReportLoading: setIsAssignmentEngagementReportLoading,
    setIsStudentEngagementReportLoading: setIsStudentEngagementReportLoading,
    setTotalCompletedAssignments: setTotalCompletedAssignments,
    setAssignmentSummaryCard: setAssignmentSummaryCard,
    setReportLoading: setReportLoading,
    setIsCourseAggregateReportLoading: setIsCourseAggregateReportLoading,
    setFeatureItems: setFeatureItems,
    setStudentEngagement: setStudentEngagement,
    setAssignmentEngagement: setAssignmentEngagement,
    setCourseAggregateData: setCourseAggregateData,
    setCourseAggregateOriginalData: setCourseAggregateOriginalData,
    fetchAssignmentDetailReport: fetchAssignmentDetailReport,
    fetchAssignmentEngagementReport: fetchAssignmentEngagementReport,
    fetchStudentEngagementReport: fetchStudentEngagementReport,
    fetchFeatureItems: fetchFeatureItems,
    fetchEngagementSummaryReport: fetchEngagementSummaryReport,
    initializeCourseSectionRoles: initializeCourseSectionRoles,
    setSelectedStudentId: setSelectedStudentId,
    setEngagementSummary: setEngagementSummary,
    setIsEngagementSummaryLoading: setIsEngagementSummaryLoading
};
var reducer = handleActions((_a = {},
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return state.merge(payload);
    },
    _a[actions.setStudentEngagement] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentEngagement', payload.data);
    },
    _a[actions.setAssignmentEngagement] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentEngagement', payload);
    },
    _a[actions.setAssignmentTypeOptions] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentTypeOptions', payload);
    },
    _a[actions.setEngagementSummary] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'engagementSummary', payload);
    },
    _a[actions.setCourseAggregateData] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'courseAggregateData', payload);
    },
    _a[actions.setCourseAggregateOriginalData] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'courseAggregateOriginalData', payload);
    },
    _a[actions.setIsEngagementSummaryLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isEngagementSummaryLoading', payload);
    },
    _a[actions.setIsAssignmentEngagementReportLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isAssignmentEngagementReportLoading', payload);
    },
    _a[actions.setIsStudentEngagementReportLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isStudentEngagementReportLoading', payload);
    },
    _a[actions.setIsCourseAggregateReportLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCourseAggregateReportLoading', payload);
    },
    _a[actions.setAssignmentEngagementCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentEngagementCardAndTableSortInteraction', payload);
    },
    _a[actions.setEngagementSummaryCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'engagementSummaryCardAndTableSortInteraction', payload);
    },
    _a[actions.setStudentEngagementSort] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentEngagementSort', payload);
    },
    _a[actions.setAssignmentSummaryCardAndTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentSummaryCardAndTableSortInteraction', payload);
    },
    _a[actions.setStudentHomeCardAndAssignmentEngagementTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentHomeCardAndAssignmentEngagementTableSortInteraction', payload);
    },
    _a[actions.setStudentHomeCardPerformLinkAndAssignmentSummaryTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentHomeCardPerformLinkAndAssignmentSummaryTableSortInteraction', payload);
    },
    _a[actions.setStudentHomeCardPerformLinkAndAssignmentEngagementTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentHomeCardPerformLinkAndAssignmentEngagementTableSortInteraction', payload);
    },
    _a[actions.setStudentDetailCardAndAssignmentSummaryTableSortInteraction] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentDetailCardAndAssignmentSummaryTableSortInteraction', payload);
    },
    _a[actions.setAssignmentInfo] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentInfo', payload.data);
    },
    _a[actions.setAssignmentDetail] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentDetail', payload.data);
    },
    _a[actions.setReportLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isReportLoading', payload);
    },
    _a[actions.setFeatureItems] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'featureItems', payload.data);
    },
    _a[actions.setIsAssignmentDetailLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isAssignmentDetailLoading', payload);
    },
    _a[actions.setSelectedStudentId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedStudentId', payload);
    },
    _a[actions.setTotalCompletedAssignments] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'totalCompletedAssignments', payload);
    },
    _a[actions.setAssignmentSummaryCard] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignmentSummaryCard', payload);
    },
    _a), initialState);
var getCwState = function (state) { return state[AppConstant.reduxResources.CW_STATE]; };
var selectors = {
    getStudentEngagement: createSelector(getCwState, function (state) { return Immutable.asMutable(state.studentEngagement || {}, { deep: true }); }),
    getAssignmentEngagement: createSelector(getCwState, function (state) { return Immutable.asMutable(state.assignmentEngagement || {}, { deep: true }); }),
    getAssignmentTypeOptions: createSelector(getCwState, function (state) { return state.assignmentTypeOptions; }),
    getEngagementSummary: createSelector(getCwState, function (state) { return state.engagementSummary; }),
    getCourseAggregateData: createSelector(getCwState, function (state) { return state.courseAggregateData; }),
    getCourseAggregateOriginalData: createSelector(getCwState, function (state) { return state.courseAggregateOriginalData; }),
    getIsEngagementSummaryLoading: createSelector(getCwState, function (state) { return state.isEngagementSummaryLoading; }),
    getAssignmentSummaryCardAndTableSortInteraction: createSelector(getCwState, function (state) { return state.assignmentSummaryCardAndTableSortInteraction; }),
    getStudentEngagementSort: createSelector(getCwState, function (state) { return state.studentEngagementSort; }),
    getAssignmentEngagementCardAndTableSortInteraction: createSelector(getCwState, function (state) { return state.assignmentEngagementCardAndTableSortInteraction; }),
    getEngagementSummaryCardAndTableSortInteraction: createSelector(getCwState, function (state) { return state.engagementSummaryCardAndTableSortInteraction; }),
    getStudentHomeCardAndAssignmentEngagementTableSortInteraction: createSelector(getCwState, function (state) { return state.studentHomeCardAndAssignmentEngagementTableSortInteraction; }),
    getStudentHomeCardPerformLinkAndAssignmentSummaryTableSortInteraction: createSelector(getCwState, function (state) { return state.studentHomeCardPerformLinkAndAssignmentSummaryTableSortInteraction; }),
    getStudentHomeCardPerformLinkAndAssignmentEngagementTableSortInteraction: createSelector(getCwState, function (state) { return state.studentHomeCardPerformLinkAndAssignmentEngagementTableSortInteraction; }),
    getStudentDetailCardAndAssignmentSummaryTableSortInteraction: createSelector(getCwState, function (state) { return state.studentDetailCardAndAssignmentSummaryTableSortInteraction; }),
    getAssignmentReport: createSelector(getCwState, function (state) { return state.assignmentReport; }),
    getReportLoading: createSelector(getCwState, function (state) { return state.isReportLoading; }),
    getAssignmentEngagementReportLoading: createSelector(getCwState, function (state) { return state.isAssignmentEngagementReportLoading; }),
    getStudentEngagementReportLoading: createSelector(getCwState, function (state) { return state.isStudentEngagementReportLoading; }),
    getIsAssignmentDetailLoading: createSelector(getCwState, function (state) { return state.isAssignmentDetailLoading; }),
    getIsCourseAggregateReportLoading: createSelector(getCwState, function (state) { return state.isCourseAggregateReportLoading; }),
    getAssignmentInfo: createSelector(getCwState, function (state) { return state.assignmentInfo; }),
    getAssignmentDetail: createSelector(getCwState, function (state) { return state.assignmentDetail; }),
    getSelectedStudentId: createSelector(getCwState, function (state) { return state.selectedStudentId; }),
    getTotalCompletedAssignments: createSelector(getCwState, function (state) { return state.totalCompletedAssignments; }),
    getAssignmentSummaryCard: createSelector(getCwState, function (state) { return state.assignmentSummaryCard; })
};
export { actions as cwActions, reducer as cwReducer, selectors as cwSelectors };
export { initialState as cwInitialState };
